var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDark = function SvgDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22c3.086 0 5.898-1.367 7.773-3.672.274-.351-.039-.86-.468-.781-4.844.937-9.297-2.774-9.297-7.695a7.795 7.795 0 0 1 3.945-6.797.461.461 0 0 0-.156-.86C14.21 2.078 13.625 2.04 13 2 7.453 2 3 6.492 3 12a9.97 9.97 0 0 0 10 10Z",
    fill: "currentColor"
  })));
};
export default SvgDark;